import api from "./api";

export const getOneCompany = async (cnpjs) => {
    return api.get(`companies/by_cnpj/${cnpjs}`);
}
